import React, { useState } from "react";
import styles from "./HeaderComponent.module.css";
import SubmitButton from "../submitButton/SubmitButton";
import SearchInput from "../searchInput/SearchInput";
import { SearchOutlined } from "@ant-design/icons";
import TextComponent from "../textComponent/TextComponent";
import filtericon from "../../assets/images/filter.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/images/editIcon.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/images/archive.svg";

import ModalComponent from "../modal/ModalComponent";
import { useNavigate } from "react-router-dom";

const HeaderComponent = ({
  heading,
  onSearch,
  onSubmit,
  headerStyle,
  headingStyle,
  rightControlsStyle,
  searchDivStyle,
  searchInputStyle,
  filtericonDivStyle,
  filtericonStyle,
  submitButtonDivStyle,
  showBackIcon,
  showFilterIcon,
  showSubmitButton,
  showSearch,
  submitButtonText,
  searchControlsStyle,
  showControlButtons,
  onDelete,
  onEdit,
  children,
  childrenStyle,
  onClickFilter,
  showTwoButton,
  CancelButtonText,
  OkButtonText,
  onSubmitCancelButton,
  onSubmitOkButton,
  CancelButtonDivStyle,
  OkButtonDivStyle,
}) => {
  const [ArchiveModal, setArchiveModal] = useState(false);
  const navigate = useNavigate();
  return (
    <div className={`${headerStyle} ${styles.headingDiv}`}>
      <TextComponent
        backIcon={showBackIcon ? true : false}
        className={`${headingStyle} ${styles.Heading}`}
        text={heading}
      />
      <div className={`${rightControlsStyle} ${styles.rightControls}`}>
        <div className={`${searchControlsStyle} ${styles.searchControlsStyle}`}>
          {showSearch && (
            <div className={`${searchDivStyle} ${styles.search_div}`}>
              <SearchInput
                placeholder="Search..."
                rightIcon={<SearchOutlined />}
                className={`${searchInputStyle} ${styles.searchInput}`}
                onChange={onSearch}
              />
            </div>
          )}

          {showFilterIcon && (
            <div className={`${filtericonDivStyle} ${styles.topIconDiv}`}>
              <img
                src={filtericon}
                alt="icon"
                className={`${filtericonStyle} ${styles.topIcon}`}
                onClick={onClickFilter}
              />
            </div>
          )}
        </div>
        {children && (
          <div className={`${childrenStyle} ${styles.children}`}>
            {children}
          </div>
        )}
        {showControlButtons && (
          <div className={styles.itemsButtonDiv}>
            <ArchiveIcon
              className={styles.itemsButton}
              onClick={() => setArchiveModal(true)}
            />
            <EditIcon className={styles.itemsButton} onClick={onEdit} />
          </div>
        )}
        {showSubmitButton && (
          <div className={`${submitButtonDivStyle} ${styles.submitButtonDiv}`}>
            <SubmitButton
              title={submitButtonText || " Default"}
              style={{ marginTop: "10px", width: "100%" }}
              primary
              onClick={onSubmit}
            />
          </div>
        )}
        {showTwoButton && (
          <div className={styles.twoButtonDiv}>
            <div
              className={`${CancelButtonDivStyle} ${styles.CancelButtonDiv}`}
            >
              <SubmitButton
                title={CancelButtonText || " Default"}
                style={{ marginTop: "10px", width: "100%" }}
                secondary
                onClick={onSubmitCancelButton}
              />
            </div>
            <div className={`${OkButtonDivStyle} ${styles.OkButtonDiv}`}>
              <SubmitButton
                title={OkButtonText || " Default"}
                style={{ marginTop: "10px", width: "100%" }}
                primary
                onClick={onSubmitOkButton}
              />
            </div>
          </div>
        )}
      </div>
      <ModalComponent
        open={ArchiveModal}
        onClickOkButton={() => {
          setArchiveModal(false);
        }}
        onClickCancelButton={() => setArchiveModal(false)}
        onCancel={() => setArchiveModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // buttonTitle={"OK"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        okBtnTitle={"Yes"}
        twoButton
        cancelBtnTitle={"No"}
        onBtnPress={() => {
          navigate(-1);
          setArchiveModal(false);
        }}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </ModalComponent>
    </div>
  );
};

export default HeaderComponent;
